import { useContext } from 'react'
import './RightHeader.scss'
import { Layout, Menu, Avatar, Dropdown } from 'antd'
import {
	BellOutlined,
	LogoutOutlined,
	MailOutlined,
	MenuFoldOutlined,
	MenuUnfoldOutlined,
	UserOutlined,
} from '@ant-design/icons'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import api from '../../api/index.api'
import { AdminContext } from '../../context/admin.context'
import { ROUTE } from '../../utils/constant'
import './RightHeader.scss'

const RightHeaderComponent = ({
	toogleSidebar,
	isSidebarCollapsed,
	history,
}) => {
	const [, setAdminContext] = useContext(AdminContext)

	const handleLogout = async () => {
		await api.authentication.logOut()
		setAdminContext('')
		history.push(ROUTE.LOGIN)
	}

	const menuSetting = (
		<Menu>
			<Menu.Item key="1" icon={<LogoutOutlined />} onClick={handleLogout}>
				Log out
			</Menu.Item>
		</Menu>
	)

	return (
		<Layout.Header className="header-right">
			<Menu mode="horizontal">
				<Menu.Item onClick={toogleSidebar}>
					{isSidebarCollapsed ? (
						<MenuUnfoldOutlined />
					) : (
						<MenuFoldOutlined />
					)}
				</Menu.Item>
				<Menu.Item key="rightheader-1" className="right">
					<Dropdown overlay={menuSetting}>
						<Avatar size="default" icon={<UserOutlined />} />
					</Dropdown>
				</Menu.Item>
				<Menu.Item className="right">
					<MailOutlined />
				</Menu.Item>
				<Menu.Item className="right">
					<BellOutlined />
				</Menu.Item>
			</Menu>
		</Layout.Header>
	)
}

RightHeaderComponent.propTypes = {
	toogleSidebar: PropTypes.func,
	isSidebarCollapsed: PropTypes.bool,
	history: PropTypes.object,
}

export const RightHeader = withRouter(RightHeaderComponent)
